/**
 * @generated SignedSource<<5af2c3acd14ef4f58d3e04ba6a353386>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleSpeechInlineWidgetArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"genericArticleSpeechInlineWidgetGenericArticle" | "postiesArticleSpeechInlineWidgetPostiesArticle">;
  readonly " $fragmentType": "articleSpeechInlineWidgetArticle";
};
export type articleSpeechInlineWidgetArticle$key = {
  readonly " $data"?: articleSpeechInlineWidgetArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleSpeechInlineWidgetArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleSpeechInlineWidgetArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "genericArticleSpeechInlineWidgetGenericArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "postiesArticleSpeechInlineWidgetPostiesArticle"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "b3ef5cf78224c803be07e71d23b47c5f";

export default node;
